/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import LoaderGraphic from '../../utils/LoaderGraphic';
import CopilotSlideOut from '../CopilotSlideOut';
import ProgressBarModal from '../../progress_bar/ProgressBarModal';
import ExportDropdown from '../utils/ExportDropdown';
import EditDashboard from '../utils/EditDashboard';
import { mergeItems } from '../charts';
import FirmReport from './FirmReport';
import PRDropdownFilter from '../PRDropdownFilter';
import DashboardViewModal from '../utils/DashboardViewModal';
import ExportPracticeFirmPDF from '../ExportPracticeFirmPDF';
import { ToastContainer, toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { faAnglesLeft } from "@fortawesome/free-solid-svg-icons";
import { useTour } from '@reactour/tour';
import Modal from 'react-modal';
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';
import GenerateReportToast from '../GenerateReportToast';

const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: false,
  typographer: true,
});

const renderMarkdown = (text) => {
  if (!text) return '';
  text = text.replace(/(?:\n|^)?:::writing block(?:\n|$)?/g, '');
  return DOMPurify.sanitize(md.render(text), {
    ALLOWED_ATTR: ['style', 'href', 'target', 'rel', 'class'],
  });
};

const sanitizeOptions = {
  ALLOWED_TAGS: [
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'td',
    'th',
    'colgroup',
    'col',
    'h1','h2','h3','h4','h5','h6',
    'br','p','ul','ol','li','hr','div',
    'strong','em','u','s','a','span','mark'
  ],
  ALLOWED_ATTR: [
    'href', 'target', 'rel', 'style', 'dir', 'class', 'colspan', 'rowspan', 'colwidth', 'data-colwidth'
  ]
};

const debounce = (fn, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), delay);
  };
};

const lastTabs = ['naics-analysis', 'dashboard'];

const FirmReportContainer = (props) => {
  const componentRefs = useRef();
  const navbar = window.navbar.navbar;
  const { isOpen, currentStep, steps, setIsOpen, setCurrentStep } = useTour();
  const [copilotOpen, setCopilotOpen] = useState(false)
  const [reportsOnTabs, setReportsOnTabs] = useState([
    { key: 'naics-analysis', checked: true, name: 'NAICS Analysis', display_on_tab: true, active_view: true, tab_order: 1, multiple_reports: false, report: "naics-analysis" },
    { key: 'dashboard', checked: true, name: 'Dashboard', display_on_tab: true, active_view: false, tab_order: 2, multiple_reports: false, report: "dashboard" },
  ])
  const [naicsTabs, setNaicsTabs] = useState([])
  const [naicsSubTabs, setNaicsSubTabs] = useState([])
  const [practiceTableState, setPracticeTableState] = useState({
    'All': {
      submitted: {
        sort: 'company_name',
        isDesc: false,
        pageCounter: 1
      },
      unsubmitted: {
        sort: 'company_name',
        isDesc: false,
        pageCounter: 1
      }
    }
  })
  const [activeTab, setActiveTab] = useState('naics-analysis');
  const [isLoading, setIsLoading] = useState(false)
  const [practiceCalcsProgressBar, setPracticeCalcsProgressBar] = useState(false);
  const [naicsSortConfig, setNaicsSortConfig] = useState({
    sortBy: 'naics',
    isDesc: true
  })
  const [data, setData] = useState({
    naics_averages: '',
    average_of_all_submitted_children: '',
    dashboard_calculations: '',
    submitted_children: '',
    report_metrics: '',
    child_count: '',
    unsubmitted_child_count: 0,
    drillup: '',
    drillup_link: '',
    drillup_text: '',
    filterOptions: '',
    firm_name: '',
    firm_logo: '',
    user_focused_clients_info: [],
    user_focused_clients: [],
    insufficientData: null,
    page: '',
    pieTopLevelArr: '',
    rankingData: '',
    tree: '',
    naics_trends_data: [],
    naics_rank_present: false,
    unsubmitted_children: '',
    user: 0,
    year: '',
    yearRange: ''
  })

  const [practiceData, setPracticeData] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({
    naics_string: 'All',
    revenue_band: 'All',
    region: 'All',
    partner: 'All',
    office: 'All',
    status: 'All',
    year: new Date().getFullYear() - 1,
  })
  const [dashboard, setDashboard] = useState({ id: null, selectedItems: [], layout: [], noChangesMade: true });
  const [dashboardViewModalState, setDashboardViewModalState] = useState({
    isOpen: false,
    action: 'close',
    edit_view: {},
    current_view: {},
    user_views: [],
    firms_views: []
  });
  const [naicsDashLayouts, setNaicsDashLayouts] = useState([])
  const [filtersModalIsOpen, setFiltersModalIsOpen] = useState(false)
  const [industryRankModalOpen, setIndustryRankModalOpen] = useState(false)
  const [rankError, setRankError] = useState('');
  const [includeIndustryRankings, setIncludeIndustryRankings] = useState([])
  const [excludeIndustryRankings, setExcludeIndustryRankings] = useState([])
  const [industryRankLoading, setIndustryRankLoading] = useState(false);
  const [activePopover, setActivePopover] = useState(null)
  const [noteTabs, setNoteTabs] = useState([])
  const [companyNotes, setCompanyNotes] = useState([{ id: null, notes: '', preference_id: null }])
  const [activeCompanyNote, setActiveCompanyNote] = useState({ id: null, notes: '', preference_id: null })
  const [openNotesForm, setOpenNotesForm] = useState(false)
  const [notesInput, setNotesInput] = useState({ error: null, name: '', permissions: 'private' })
  const [PDFPrintModalOpen, setPDFPrintModalOpen] = useState(false)
  const [displayPages, setDisplayPages] = useState([
    { title: 'NAICS Analysis', checked: true },
    { title: 'Dashboard', checked: true }
  ])
  const [generatingReports, setGeneratingReports] = useState(false);
  const [generatedReports, setGeneratedReports] = useState([]);
  const [reportGenerationCount, setReportGenerationCount] = useState(0);
  const [generatedNotesByTab, setGeneratedNotesByTab] = useState([]);
  const toastId = useRef('generating-reports');
  const subscriptionRefs = useRef([]);
  const industryRecommendRef = useRef(null)
  const completedMainJobsRef = useRef(0);
  const completedNAICSSubJobsRef = useRef(0);
  const firstCompletedTabRef = useRef(null);
  const firstCompletedSubTabRef = useRef(null);
  const totalJobsRef = useRef(0);
  const totalSubJobsRef = useRef(0);
  const debouncedSave = useRef(null);
  const latestNoteRef = useRef(null);

  useEffect(() => {
    setIsLoading(true)
    let allUrl = `/api/v1/practice_reportable?report=firm&naics_string=${selectedFilters.naics_string === 'All' ? '' : selectedFilters.naics_string}&revenue_band=${selectedFilters.revenue_band === 'All' ? '' : selectedFilters.revenue_band}&region=${selectedFilters.region === 'All' ? '' : selectedFilters.region}&partner=${selectedFilters.partner === 'All' ? '' : selectedFilters.partner}&office=${selectedFilters.office === 'All' ? '' : selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`
    const makeApiCall = async () => {
      const response = await fetch(allUrl);
      const json = await response.json();
      setData(prevState => {
        return {
          ...prevState,
          naics_averages: json.naics_averages,
          naics_rank_present: json.naics_rank_present,
          dashboard_calculations: json.dashboard_calculations,
          child_count: json.child_count,
          drillup: json.drillup,
          drillup_link: json.drillup_link,
          drillup_text: json.drillup_text,
          filterOptions: json.filter_options_obj,
          firm_name: json.firm_name,
          firm_logo: json.firm_logo,
          user_focused_clients_info: json.user_focused_clients_info,
          insufficientData: json.insufficient_data,
          page: json.page,
          pieTopLevelArr: json.pie_top_level_arr,
          selected_filters: json.selected_filters,
          rankingData: json.snapshot_info,
          tree: json.tree,
          user: json.user,
          year: json.year,
          yearRange: json.yearRange,
        }
      })
      const activeTabFromCall = json.all_tabs.find(tab => tab.active_view)
      setActiveTab(prevState => {
        return activeTabFromCall?.key || prevState
      })
      setGeneratedNotesByTab(json.generated_notes_by_tab || {})
      setReportsOnTabs(json.all_tabs.filter(t => t.display_on_tab).sort((a, b) => a.tab_order - b.tab_order) || [])
      setNoteTabs(json.note_tabs || [])
      setCompanyNotes(json.firm_notes || [{ id: null, notes: '', preference_id: null }])
      setSelectedFilters(prevState => {
        return {
          ...prevState,
          naics_string: json.selected_filters.naics_string ||= 'All',
          revenue_band: json.selected_filters.revenue_band ||= 'All',
          region: json.selected_filters.region ||= 'All',
          partner: json.selected_filters.partner ||= 'All',
          office: json.selected_filters.office ||= 'All',
          status: json.selected_filters.status ||= 'All',
          year: json.year
        }
      })
      setNaicsDashLayouts(prevState => {
        return [...prevState, ...json.naics_dash_layouts]
      })
      setIncludeIndustryRankings(json.naics_rank.filter(r => r.included) || [])
      setExcludeIndustryRankings(json.naics_rank.filter(r => !r.included) || [])

      const dashBoard = await fetch(`/get_dashboard_view/?report_type=firm`, {
        headers: {
          'X-CSRF-Token': window.token,
        }
      })
      const dashBoardRes = await dashBoard.json();
      let currentDash = dashBoardRes['current_view']
      let { layout, selectedItems } = mergeItems('practice', currentDash.selected_items, currentDash.dashboard_layout)
      setDashboard(() => {
        return {
          id: currentDash.id,
          selectedItems: selectedItems,
          layout: layout,
          noChangesMade: true
        }
      })
      setDashboardViewModalState((prevState) => {
        return {
          ...prevState,
          current_view: dashBoardRes.current_view,
          user_views: dashBoardRes.user_views,
          firms_views: dashBoardRes.firms_views
        }
      })

      props.tracker_id && !props.tour_taken ? setIsOpen(true) : null

      if (activeTabFromCall?.report === 'generated_naics_main_tab') {
        practiceApiCall(activeTabFromCall.details)
      } else {
        setIsLoading(false);
      }
    };
    makeApiCall();
  }, [])

  useEffect(() => {
    return () => {
      subscriptionRefs.current.forEach((sub) => sub.unsubscribe());
      subscriptionRefs.current = [];
    };
  }, [])

  const practiceApiCall = async (tabInfo) => {
    setIsLoading(true);
    const naicsCode = tabInfo?.naics_string || tabInfo?.code;
    const revenueBand = tabInfo['revenue_band']
    const region = tabInfo['region']
    const partner = tabInfo['partner']
    const office = tabInfo['office']
    const status = tabInfo['status']
    const year = tabInfo['year']
    const tableSettings = practiceTableState?.[naicsCode]?.['submitted']
    ? practiceTableState[naicsCode]
    : {
      submitted: {
        sort: 'company_name',
        isDesc: false,
        pageCounter: 1
      },
      unsubmitted: {
        sort: 'company_name',
        isDesc: false,
        pageCounter: 1
      }
    }
    let allUrl = `/api/v1/practice_reportable?report=generated_naics_main_tab&page=${tableSettings.submitted.pageCounter}&rows=${'25'}&sort=${tableSettings.submitted.sort}&direction=${tableSettings.submitted.isDesc ? 'desc' : 'asc'}&naics_string=${naicsCode === 'All' ? '' : naicsCode}&revenue_band=${revenueBand === 'All' ? '' : revenueBand}&region=${region === 'All' ? '' : region}&partner=${partner === 'All' ? '' : partner}&office=${office === 'All' ? '' : office}&status=${status === 'All' ? '' : status}&year=${year}&commit=filter`
    const response = await fetch(allUrl);
    const json = await response.json();

    setPracticeData(prevState => {
      return {
        ...prevState,
        [naicsCode]: json
      }
    })

    setPracticeTableState(prevState => {
      return {
        ...prevState,
        [naicsCode]: tableSettings
      }
    })

    setIsLoading(false);
  }

  const handlePDFandPrintChecked = (title) => {
    setDisplayPages(prevState => {
      return prevState.map((page) => {
        if (page.title === title) {
          return { ...page, checked: !page.checked }
        }
        return page
      })
    })
  }

  useEffect(() => {
    setDisplayPages(prevState => {
      const coreTitles = ['NAICS Analysis', 'Dashboard']
      const corePages = coreTitles.map((title) => {
        const existing = prevState.find((page) => page.title === title)
        return {
          title,
          checked: existing ? existing.checked : true,
        }
      })
      const notePages = noteTabs.map((tab) => {
        const existing = prevState.find((page) => page.title === tab.name)
        return {
          title: tab.name,
          checked: existing ? existing.checked : true,
        }
      })
      return [...corePages, ...notePages]
    })
  }, [noteTabs])

  const handleFocusedClients = async (clientType, clientInfo) => {
    const currentTab = reportsOnTabs.find((tab) => tab.key === activeTab);
    const activePracticeKey = currentTab?.details?.naics_string || currentTab?.details?.code;
    const currentPracticeData = practiceData?.[activePracticeKey];
    const currentFocusedClients = currentPracticeData?.user_focused_clients || [];
    let clientFocused = !clientInfo.focused_client;
    let allFocusedClients = [...currentFocusedClients];

    if (clientFocused) {
      const clientExists = allFocusedClients.find((c) => c === clientInfo.company_id);
      if (!clientExists) {
        allFocusedClients.push(clientInfo.company_id);
      }
    } else {
      allFocusedClients = allFocusedClients.filter((c) => c !== clientInfo.company_id);
    }

    const updatedFocus = { focused_clients: allFocusedClients };

    try {
      const res = await fetch(`/api/v1/users/${currentPracticeData?.user || data.user}`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedFocus),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      }

      const json = await res.json();
      setPracticeData((prevState) => {
        const nextState = prevState ? { ...prevState } : {};
        const targetData = nextState[activePracticeKey];

        if (!targetData) {
          return nextState;
        }

        const focusedClients = clientType === 'clients-submitted'
          ? _.cloneDeep(targetData?.submitted_children || [])
          : _.cloneDeep(targetData?.unsubmitted_children || []);

        const targetClient = focusedClients.find((c) => c.company_id === clientInfo.company_id);
        if (targetClient) {
          targetClient.focused_client = !clientInfo.focused_client;
        }

        if (clientType === 'clients-submitted') {
          nextState[activePracticeKey] = {
            ...targetData,
            user_focused_clients_info: json.focused_clients,
            user_focused_clients: allFocusedClients,
            submitted_children: focusedClients,
          };
        }

        if (clientType === 'clients-unsubmitted') {
          nextState[activePracticeKey] = {
            ...targetData,
            user_focused_clients_info: json.focused_clients,
            user_focused_clients: allFocusedClients,
            unsubmitted_children: focusedClients,
          };
        }

        return nextState;
      });
    } catch (error) {
      console.log(error);
      toast.error('Sorry something went wrong. Changes were not saved properly.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  };

  const handleTableChanges = async (action, clientType, dataValue) => {
    const currentTab = reportsOnTabs.find((tab) => tab.key === activeTab);
    const activePracticeKey = currentTab?.details?.naics_string || currentTab?.details?.code;
    const currentPracticeTableState = practiceTableState?.[activePracticeKey] || {
      submitted: {
        sort: 'company_name',
        isDesc: false,
        pageCounter: 1,
      },
      unsubmitted: {
        sort: 'company_name',
        isDesc: false,
        pageCounter: 1,
      },
    };

    setIsLoading(true);
    let sortTableUrl = '';

    if (action === 'changePage') {
      setPracticeTableState((prevState) => {
        const nextState = prevState ? { ...prevState } : {};
        const currentTabState = nextState[activePracticeKey] || {
          submitted: {
            sort: 'company_name',
            isDesc: false,
            pageCounter: 1,
          },
          unsubmitted: {
            sort: 'company_name',
            isDesc: false,
            pageCounter: 1,
          },
        };

        if (clientType === 'submitted') {
          nextState[activePracticeKey] = {
            ...currentTabState,
            submitted: { ...currentTabState.submitted, pageCounter: dataValue },
          };
        } else {
          nextState[activePracticeKey] = {
            ...currentTabState,
            unsubmitted: { ...currentTabState.unsubmitted, pageCounter: dataValue },
          };
        }

        return nextState;
      });

      sortTableUrl = `/api/v1/practice_reportable?report=generated_naics_main_tab&client_type=${clientType}&page=${dataValue}&rows=25&sort=${currentPracticeTableState[clientType].sort}&direction=${currentPracticeTableState[clientType].isDesc ? 'desc' : 'asc'}&naics_string=${activePracticeKey === 'All' ? '' : activePracticeKey}&revenue_band=${selectedFilters.revenue_band === 'All' ? '' : selectedFilters.revenue_band}&region=${selectedFilters.region === 'All' ? '' : selectedFilters.region}&partner=${selectedFilters.partner === 'All' ? '' : selectedFilters.partner}&office=${selectedFilters.office === 'All' ? '' : selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`;
    }

    if (action === 'sort') {
      setPracticeTableState((prevState) => {
        const nextState = prevState ? { ...prevState } : {};
        const currentTabState = nextState[activePracticeKey] || {
          submitted: {
            sort: 'company_name',
            isDesc: false,
            pageCounter: 1,
          },
          unsubmitted: {
            sort: 'company_name',
            isDesc: false,
            pageCounter: 1,
          },
        };

        if (clientType === 'submitted') {
          nextState[activePracticeKey] = {
            ...currentTabState,
            submitted: {
              sort: dataValue,
              isDesc: !currentTabState.submitted.isDesc,
              pageCounter: currentTabState.submitted.pageCounter,
            },
          };
        } else {
          nextState[activePracticeKey] = {
            ...currentTabState,
            unsubmitted: {
              sort: dataValue,
              isDesc: !currentTabState.unsubmitted.isDesc,
              pageCounter: currentTabState.unsubmitted.pageCounter,
            },
          };
        }

        return nextState;
      });

      sortTableUrl = `/api/v1/practice_reportable?report=generated_naics_main_tab&client_type=${clientType}&page=${currentPracticeTableState[clientType].pageCounter}&rows=25&sort=${dataValue}&direction=${!currentPracticeTableState[clientType].isDesc ? 'desc' : 'asc'}&naics_string=${activePracticeKey === 'All' ? '' : activePracticeKey}&revenue_band=${selectedFilters.revenue_band === 'All' ? '' : selectedFilters.revenue_band}&region=${selectedFilters.region === 'All' ? '' : selectedFilters.region}&partner=${selectedFilters.partner === 'All' ? '' : selectedFilters.partner}&office=${selectedFilters.office === 'All' ? '' : selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`;
    }

    const response = await fetch(sortTableUrl);
    const json = await response.json();

    setPracticeData((prevState) => {
      const nextState = prevState ? { ...prevState } : {};
      const targetData = nextState[activePracticeKey];

      if (!targetData) {
        return nextState;
      }

      if (clientType === 'submitted') {
        nextState[activePracticeKey] = {
          ...targetData,
          submitted_children: json.submitted_children,
        };
      } else {
        nextState[activePracticeKey] = {
          ...targetData,
          unsubmitted_children: json.unsubmitted_children,
        };
      }

      return nextState;
    });

    setIsLoading(false);
  };

  const createCompanyNotes = async (cleanHTML, tab = null, makeActiveTab = true, note_type = null) => {
    if (['firm_notes', 'generated_firm_notes', 'generated_naics_notes'].includes(tab?.report) || ['firm_notes', 'generated_firm_notes', 'generated_naics_notes'].includes(activeTab?.report)) {
      const newActiveTab = tab ? tab : activeTab
      setIsLoading(true)
      try {
        const res = await fetch(`/api/v1/company_notes`, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            company_note: {
              notes: cleanHTML,
              preference_id: newActiveTab.id,
              note_type: note_type,
              copilot_prompt_id: tab?.copilot_prompt_id,
              filters: selectedFilters,
            }
          }),
        })

        const resJson = await res.json()

        if (!res.ok) {
          throw new Error('Network response was not ok. Could not save note changes.')
        } else {
          const notes = resJson.message === 'exists' ? resJson.notes : cleanHTML
          const newNote = { ...resJson, notes: notes, can_edit: true }
          if (!note_type) {
            newNote['preference_id'] = newActiveTab.id
          }

          if (makeActiveTab) {
            setActiveCompanyNote(newNote)
          }
          // Normal and Generated notes get stored here
          setCompanyNotes(prevState => {
            return [...prevState, newNote]
          })

          if (note_type === 'generated') {
            // Need to update the tab to point to the correct note
            setReportsOnTabs(prevState => {
              // NAICS sub tab generated reports
              if (newActiveTab.report === "generated_naics_notes") {
                const tabExists = prevState.find(t => t.id == newActiveTab.parent_id)
                if (tabExists) {
                  return prevState.map((t) => {
                    if (t.id == newActiveTab.parent_id) {
                      t.sub_tabs = t.sub_tabs.map(s => s.id == newActiveTab.id ? { ...s, active_note_id: newNote.id, can_edit: true } : s)
                    }
                    return t
                  })
                } else {
                  return [...prevState, { ...newActiveTab, active_note_id: newNote.id, can_edit: true }]
                }
              } else {
                // Main Tabs generated reports and normal notes
                const tabExists = prevState.find(t => t.id == newActiveTab.id)
                if (tabExists) {
                  return prevState.map(t => t.id == newActiveTab.id ? { ...t, active_note_id: newNote.id, can_edit: true } : t)
                } else {
                  return [...prevState, { ...newActiveTab, active_note_id: newNote.id, can_edit: true }]
                }
              }
            })
            // Add new note to the tab's notes version list for select input
            setGeneratedNotesByTab(prevState => {
              if (prevState[newActiveTab.id]) {
                return {
                  ...prevState,
                  [newActiveTab.id]: [newNote, ...prevState[newActiveTab.id]]
                }
              } else {
                return {
                  ...prevState,
                  [newActiveTab.id]: [newNote]
                }
              }
            })
          }
          setIsLoading(false)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }

  const updateCompanyNotes = async (cleanHTML, note) => {
    try {
      if (note.notes !== cleanHTML) {
        const res = await fetch(`/api/v1/company_notes/${note.id}`, {
          method: 'PATCH',
          headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            company_note: {
              notes: cleanHTML
            }
          }),
        })

        setCompanyNotes(prevState => {
          return prevState.map(n => {
            return n.id === note.id ? { ...n, notes: cleanHTML } : n
          })
        })

        if (!res.ok) {
          throw new Error('Network response was not ok. Could not save note changes.')
        }
      }
    } catch (e) {
      console.log(e)
    }
  }

  const handleGenereateNoteChange = async (noteId, subTab = null) => {
    setIsLoading(true)
    const userNote = companyNotes.find(n => n.id == noteId)
    let updates = [];

    const newTabs = reportsOnTabs.map((t) => {
      if (t.key === activeTab) {
        // Naics sub tabs generated reports notes
        if (t.report === 'generated_naics_main_tab') {
          t.sub_tabs = t.sub_tabs.map((s) => {
            if ((s.report === "generated_naics_notes") && (s.id == subTab.id)) {
              updates.push({ ...s, active_note_id: Number(noteId) });
              return { ...s, active_note_id: Number(noteId) };
            } else {
              return s;
            }
          })
        } else {
          // Main tabs with generated notes and normal notes
          updates.push({ ...t, active_note_id: Number(noteId) });
          return { ...t, active_note_id: Number(noteId) };
        }
      }
      return t;
    });

    try {
        const res = await fetch(`/api/v1/preferences/update_views`, {
            method: 'PATCH',
            headers: {
                'X-CSRF-Token': window.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              updates: updates
            })
        })
        const resJson = await res.json();
        if (!res.ok) {
          throw new Error('Network response was not ok.')
        } else {
          setActiveCompanyNote(prevState => {
            return { ...prevState, notes: userNote.notes }
          })

          setReportsOnTabs(newTabs);

          setIsLoading(false)
        }
      } catch (error) {
        console.log(error)
        alert(`Sorry something went wrong. ${error}`)
      }
  }

  const revertToGeneratedReponse = async (noteId) => {
    if (!confirm('Are you sure you want to get rid of your changes?')) return;
    setIsLoading(true)
    try {
        const res = await fetch(`/api/v1/get_generated_copy`, {
            method: 'POST',
            headers: {
                'X-CSRF-Token': window.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: noteId
            })
        })
        const resJson = await res.json();
        if (!res.ok) {
          throw new Error('Network response was not ok.')
        } else {
          // update notes here
          setActiveCompanyNote(prevState => {
            return { ...prevState, notes: resJson.notes }
          })

          setCompanyNotes(prevState => {
            return prevState.map(n => {
              return  n.id == noteId ? { ...n, notes: resJson.notes } : n
            })
          })

          setIsLoading(false)
        }
      } catch (error) {
        console.log(error)
        alert(`Sorry something went wrong. ${error}`)
      }
  }

  const createNewNotesTab = async (e) => {
    e.preventDefault();

    if (notesInput.name.length === 0) {
      setNotesInput(prevState => {
        return {
          ...prevState, error: 'Please enter a name for the new tab.'
        }
      })
    } else {
      let tabOrder = reportsOnTabs.length + 1
      try {
        const res = await fetch(`/api/v1/preferences/new_notes_tab`, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': window.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            key: 'firm_notes',
            name: notesInput.name,
            report: 'firm_notes',
            permissions: notesInput.permissions,
            page: 'firm',
            tab_order: tabOrder
          }),
        })

        const resJson = await res.json();

        if (!res.ok) {
          throw new Error('Network response was not ok.')
        } else {
          const newNote = resJson.active_note
          newNote.can_edit = true

          setNoteTabs(prevState => {
            return [...prevState, newNote]
          })
          setOpenNotesForm(false)
          createCompanyNotes('', newNote)
          updateTabActiveView(newNote, 'addNote')
          toast.success('New Notes Tab Created!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          })
        }
      } catch (error) {
        console.log(error)
        alert('Sorry something went wrong. Changes were not saved properly.')
      }
    }
  }

  const deleteReportTab = async (noteTab) => {
    const isActiveTab = noteTab.key === activeTab
    try {
      const res = await fetch(`/api/v1/preferences/${noteTab.id}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        }
      })

      if (!res.ok) {
        throw new Error('Network response was not ok.')
      } else {
        if (isActiveTab) {
          setActiveTab('naics-analysis')
          const analysisTab = reportsOnTabs.find(tab => tab.key === 'naics-analysis')
          updateTabActiveView(analysisTab)
        }
        setReportsOnTabs(prevState => {
          return  prevState.filter(tab => tab.id !== noteTab.id)
        })

        setNoteTabs(prevState => {
          return prevState.filter(tab => tab.id !== noteTab.id)
        });

        setCompanyNotes(prevState => {
          return prevState.filter(tab => tab.preference_id !== noteTab.id)
        });
      }
    } catch (error) {
      console.log(error)
      alert('Sorry something went wrong. Changes were not saved properly.')
    }
  }

  const countPlainTextCharacters = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    return plainText.length;
  }

  const onChangeNotes = useCallback(
    (note, canEdit, html) => debounce((html) => {
      if (canEdit) {
        const cleanHTML = DOMPurify.sanitize(html, sanitizeOptions);
        let characterCount = countPlainTextCharacters(cleanHTML);
        if (characterCount <= 50000) {
          if (note?.id) {
            updateCompanyNotes(cleanHTML, note)
          } else {
            createCompanyNotes(cleanHTML, null)
          }
        }
      }
    }, 2000),
    []
  );

  const handleNewNotesName = (name) => {
    setNotesInput(prevState => {
      return {
        ...prevState,
        error: null,
        name
      }
    })
  }

  const handleNotePermissions = (value) => {
    setNotesInput(prevState => {
      return {
        ...prevState,
        permissions: value
      }
    })
  }

  const handleOpenNotesForm = () => {
    setOpenNotesForm(true)
  }

  const handleCloseNotesForm = () => {
    setOpenNotesForm(false)
  }

  const updateCompanyGenerationCount = async () => {
    try {
      const res = await fetch(`/api/v1/update_report_generation_count`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          page: "firm"
        })
      })

      const resJson = await res.json()

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        setReportGenerationCount(resJson.generate_report_count)
      }
    } catch (error) {
      console.log(error)
      alert('Sorry something went wrong. Changes were not saved properly.')
    }
  }

  const unsubscribeGeneration = (chatId) => {
    const subIndex = subscriptionRefs.current.findIndex((s) => {
      const identifier = JSON.parse(s.identifier);
      return identifier.chat_id == chatId; // loose == handles number/string mismatch
    });

    if (subIndex !== -1) {
      subscriptionRefs.current[subIndex].unsubscribe();
      subscriptionRefs.current.splice(subIndex, 1);
    }
  };

  const subscribeToCopilotNAICSSubGeneration = (chatId, tab, activeTab, onConnected) => {
    let resolved = false;

    const resolve = () => {
      if (!resolved) {
        resolved = true;
        if (onConnected) onConnected();
      }
    };

    const sub = App.cable.subscriptions.create(
      {
        channel: 'FirmCopilotChannel',
        chat_id: chatId,
      },
      {
        connected() {
          console.log('sub connected fired for', chatId);
          resolve();
        },
        received: (data) => {
          console.log(data, chatId, 'data')
          if (data.finish && data.message) {
            if (!firstCompletedSubTabRef.current && activeTab) {
              firstCompletedSubTabRef.current = activeTab;
            }
            completedNAICSSubJobsRef.current += 1;

            const htmlFromMark = renderMarkdown(data.message.display_content);
            const cleanHTML = DOMPurify.sanitize(htmlFromMark, sanitizeOptions);
            
            // Only set active tab once all jobs are done
            console.log(subscriptionRefs, completedNAICSSubJobsRef.current, totalSubJobsRef.current, "track")
            if (completedNAICSSubJobsRef.current >= totalSubJobsRef.current) {
              if (activeTab) {
                // Set New NAICS main tab if new
                setActiveTab(firstCompletedSubTabRef.current.key);
              }
              setIndustryRankModalOpen(false);
              setGeneratingReports(false);
              updateCompanyGenerationCount();
              toast.dismiss(toastId.current);
            }
            let characterCount = countPlainTextCharacters(cleanHTML);
            if (characterCount <= 60000) {
              createCompanyNotes(cleanHTML, tab, false, 'generated')
            }
            unsubscribeGeneration(data.message.id)
            
            setGeneratedReports((prev) =>
              prev.map((g) =>
                g.chat_id === data.message.id
                  ? { ...g, status: 'completed', content: data.message.display_content }
                  : g
              )
            );
          }

          if (data.error) {
            completedNAICSSubJobsRef.current += 1;
            if (completedNAICSSubJobsRef.current >= totalSubJobsRef.current) {
              setGeneratingReports(false);
              setIsLoading(false);
              toast.dismiss(toastId.current);
              toast.error('Sorry, something went wrong please try again later.', {
                position: 'top-right',
                autoClose: 8000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
              });
            }
            setGeneratedReports((prev) =>
              prev.map((g) =>
                g.chat_id === data.id
                  ? { ...g, status: 'completed', content: data.display_content }
                  : g
              )
            );
            unsubscribeGeneration(data.id)
          }
        },
      }
    );

    setTimeout(resolve, 10000);

    subscriptionRefs.current.push(sub);
  }

  const subscribeToCopilotMainGeneration = (chatId, tab, activeTab, onConnected) => {
    let resolved = false;

    const resolve = () => {
      if (!resolved) {
        resolved = true;
        if (onConnected) onConnected();
      }
    };

    const sub = App.cable.subscriptions.create(
      {
        channel: 'FirmCopilotChannel',
        chat_id: chatId,
      },
      {
        connected() {
          console.log('connected fired for', chatId);
          resolve();
        },
        received: (data) => {
          console.log(data, 'data??')
          console.log('received fired for chat_id:', chatId, data);
          if (data.finish && data.message) {
            if (!firstCompletedTabRef.current) {
              firstCompletedTabRef.current = tab;
            }
            completedMainJobsRef.current += 1;

            const htmlFromMark = renderMarkdown(data.message.display_content);
            const cleanHTML = DOMPurify.sanitize(htmlFromMark, sanitizeOptions);

            setNoteTabs(prevState => {
              if (prevState.some(t => t.id === tab.id)) return prevState;
              return [...prevState, tab];
            });
            
            // Only set active tab once all jobs are done
            if (completedMainJobsRef.current >= totalJobsRef.current) {
              setActiveTab(firstCompletedTabRef.current.key);
              setGeneratingReports(false);
              updateCompanyGenerationCount();
              toast.dismiss(toastId.current);
            }

            let characterCount = countPlainTextCharacters(cleanHTML);
            if (characterCount <= 60000) {
              createCompanyNotes(cleanHTML, tab, false, 'generated')
            }
            unsubscribeGeneration(data.message.id)
            
            setGeneratedReports((prev) =>
              prev.map((g) =>
                g.chat_id === data.message.id
                  ? { ...g, status: 'completed', content: data.message.display_content }
                  : g
              )
            );
          }

          if (data.error) {
            completedMainJobsRef.current += 1;
            if (completedMainJobsRef.current >= totalJobsRef.current) {
              setGeneratingReports(false);
              toast.dismiss(toastId.current);
              toast.error(data.error, {
                position: 'top-right',
                autoClose: 8000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
              });
            }
            setGeneratedReports((prev) =>
              prev.map((g) =>
                g.chat_id === data.id
                  ? { ...g, status: 'completed', content: data.display_content }
                  : g
              )
            );
            unsubscribeGeneration(data.id)
          }
        },
      }
    );

    setTimeout(resolve, 10000);

    subscriptionRefs.current.push(sub);
  }

  const subscribeToIndustryRecommendation = (coordinatorChatId) => {
    const sub = App.cable.subscriptions.create(
      { channel: 'FirmCopilotChannel', chat_id: coordinatorChatId },
      {
        received: (data) => {
          switch (data.type) {
            case "industries_loading":
              setIndustryRankLoading(true);
              break;
            case "industry_recommendations":
              setData(prevState => {
                return {...prevState, naics_rank_present: true}
              })
              let industriesList = data.industries.map((naics, i) => {
                if (i <= 4) {
                  naics.included = true
                } else {
                  naics.included = false
                }
                return naics
              })
              setIncludeIndustryRankings(industriesList.filter(naics => naics.included) || []);
              setExcludeIndustryRankings(industriesList.filter(naics => !naics.included) || []);
              setIndustryRankLoading(false);
              setIndustryRankModalOpen(true);
              sub.unsubscribe();
              if (completedMainJobsRef.current >= totalJobsRef.current) {
                App.cable.disconnect();
              }
              break;
            case "no_context":
            case "error":
              setIndustryRankLoading(false);
              sub.unsubscribe();
              break;
          }
        }
      }
    );
    industryRecommendRef.current = sub;
  };

  const generateNaicsSubTabs = async () => {
    if (generatingReports) return;

    if (!selectedFilters) {
      toast.error('Financial data is still loading. Please wait a moment and try again.')
      return;
    }
    setIsLoading(true)
    setGeneratingReports(true)
    completedNAICSSubJobsRef.current = 0;
    let totalMainTabs = reportsOnTabs.length - lastTabs.length > -1 ? reportsOnTabs.length - lastTabs.length : 0;

    try {
      const res = await fetch('/api/v1/preferences/firm_naics_tabs', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ page: 'firm', report: 'generated_naics_notes', include_industries: includeIndustryRankings, exclude_industries: excludeIndustryRankings, filters: selectedFilters, total_main_tabs: totalMainTabs }),
      });
      const resJson = await res.json();
      console.log(resJson, 'resjson?')

      if (res.ok) {
        let orderedTabs;

        setReportsOnTabs(prevState => {
          let newTabs = [...prevState];

          const newNAICSTabs = resJson.naics_main_tabs;

          newNAICSTabs.forEach(tab => {
            const existingIndex = newTabs.findIndex(t => t.id === tab.id);
            if (existingIndex !== -1) {
              newTabs[existingIndex] = { ...newTabs[existingIndex], ...tab };
            } else {
              newTabs.push(tab);
            }
          });

          excludeIndustryRankings.forEach(e => {
            let oldTabIndex = newTabs.findIndex(nt => nt?.details?.code === e?.code)
            if (oldTabIndex > -1) {
              newTabs.splice(oldTabIndex, 1)
            }
          })

          const endTabs = newTabs.filter(t => lastTabs.includes(t.key) || t.report === 'firm_notes');
          const otherTabs = newTabs.filter(t => !lastTabs.includes(t.key) && t.report !== 'firm_notes').sort((a, b) => a.tab_order - b.tab_order);

          // Then append non generated tab at the end
          endTabs.forEach((tab, i) => {
              tab.tab_order = otherTabs.length + 1 + i;
          });
          orderedTabs = [...otherTabs, ...endTabs];

          return orderedTabs;
        });
        saveTabOrder(orderedTabs);
        setNaicsTabs(resJson.naics_main_tabs)
        setNaicsSubTabs(resJson.naics_sub_tabs)

        const generatedSubReports = resJson.generated_reports;
        setGeneratedReports(generatedSubReports)
        totalSubJobsRef.current = resJson.generated_reports.length;
        firstCompletedSubTabRef.current = null;

        toastId.current = toast.loading('Generating Industry / NAICS AI Reports...', {
          position: 'top-right',
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });

        const connectionPromises = generatedSubReports.map((g) => {
          return new Promise((resolve) => {
            subscribeToCopilotNAICSSubGeneration(g.chat_id, g.tab, resJson.active_main_tab, resolve);
          })
        })

        // Wait for ALL subscriptions to confirm connected
        await Promise.all(connectionPromises);

        await fetch('/api/v1/copilot_v2/start_generate_naics_firm_prompts', {
          method: 'POST',
          headers: { 'X-CSRF-Token': window.token, 'Content-Type': 'application/json' },
          body: JSON.stringify({ coordinator_chat_id: resJson.coordinator_chat_id, chats: resJson.chats }),
        });
      }

    } catch (err) {
      setGeneratingReports(false);
      setIsLoading(false);
      toast.error('Failed to create Industry tabs and reports. Please wait a moment and try again.');
      console.error('Copilot error:', err);
    }
  }

  const generateAiFirmReports = async () => {
    if (generatingReports) return;

    if (!selectedFilters) {
      toast.error('Financial data is still loading. Please wait a moment and try again.')
      return;
    }

    setGeneratingReports(true)
    completedMainJobsRef.current = 0; // reset on each report generation

    try {
      const payload = { page: 'firm', report: 'generated_firm_notes', filters: selectedFilters };

      // Dara formatted for firm report must be passed to the Ask Peerview firm report prompts
      const dataGiven = data.naics_averages ?  data.naics_averages : nil
      const res = await fetch('/api/v1/preferences/firm_main_tabs', {
        method: 'POST',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
      const resJson = await res.json();

      if (res.ok) {
        let orderedTabs;

        setReportsOnTabs(prevState => {
          let newTabs = [...prevState];

          const newMainTabs = resJson.tabs;

         newMainTabs.forEach(tab => {
            const existingIndex = newTabs.findIndex(t => t.id === tab.id);
            if (existingIndex !== -1) {
              newTabs[existingIndex] = { ...newTabs[existingIndex], ...tab };
            } else {
              newTabs.push(tab);
            }
          });

          const endTabs = newTabs.filter(t => lastTabs.includes(t.key) || t.report === 'firm_notes');
          const otherTabs = newTabs.filter(t => !lastTabs.includes(t.key) && t.report !== 'firm_notes').sort((a, b) => a.tab_order - b.tab_order);
          // Then append non generated tab at the end
          endTabs.forEach((tab, i) => {
              tab.tab_order = otherTabs.length + 1 + i;
          });
          orderedTabs = [...otherTabs, ...endTabs];

          return orderedTabs;
        });
        saveTabOrder(orderedTabs);

        const generatedMainReports = resJson.generated_reports;
        setGeneratedReports(generatedMainReports);
        totalJobsRef.current = resJson.generated_reports.length;
        firstCompletedTabRef.current = null;

        toastId.current = toast.loading('Generating AI Reports...', {
          position: 'top-right',
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        });

        const connectionPromises = generatedMainReports.map((g) => {
          return new Promise((resolve) => {
            subscribeToCopilotMainGeneration(g.chat_id, g.tab, g.active_view, resolve);
          })
        })

        // Wait for ALL subscriptions to confirm connected
        await Promise.all(connectionPromises);

        subscribeToIndustryRecommendation(resJson.coordinator_chat_id);
        await fetch('/api/v1/copilot_v2/start_generate_firm_prompts', {
          method: 'POST',
          headers: { 'X-CSRF-Token': window.token, 'Content-Type': 'application/json' },
          body: JSON.stringify({ coordinator_chat_id: resJson.coordinator_chat_id, chats: resJson.chats, data_given: dataGiven, filters: selectedFilters }),
        });
      }

    } catch (err) {
      setGeneratingReports(false);
      toast.error('Failed to generate reports. Please try again later.');
      console.error('Copilot error:', err);
    }
  }

  const handleAIReportConfirmation = () => {
    toast(<GenerateReportToast generateAiReports={generateAiFirmReports} page={'Firm'} />, { position: "top-center", autoClose: false })
  }

  const dashboardSelectEditor = (itemsChecked, dashboardLayout) => {
    let itemsCheckedTrue = [];
    let newLayout = [];
    let width = 0;

    itemsChecked.forEach((itemChecked, i) => {
      // Checked list will always have children array
      if (itemChecked.checked) {
        let oldItem = dashboardLayout.find(d => d['i'] === itemChecked.key);
        if (oldItem) {
          if (itemChecked.children && itemChecked.children.length > 1) {
            let parentLayout = []
            // we found a parent and it has more than one child checked
            // Does the old layout have each child?
            // If it has a checked child return it, else create a new layout for the child
            itemChecked.children.forEach(child => {
              let newChildItem = oldItem.layout.find(o => o['i'] === child.key)
              // Can't find the child make a new one
              if (!newChildItem) {
                if (child.key.includes('ranking_table')) {
                  parentLayout.push({
                    i: child.key,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((i * 3) % (6)),
                    y: Infinity,
                    w: 2,
                    h: 2,
                    minW: 2,
                    minH: 2,
                    maxW: 4,
                    maxH: 4,
                    resizeHandles: ['se']
                  })
                } else {
                  parentLayout.push({
                    i: child.key,
                    isBounded: false,
                    isDraggable: true,
                    isResizable: true,
                    x: ((i * 3) % (6)),
                    y: Infinity,
                    w: 3,
                    h: 2,
                    minW: 3,
                    minH: 2,
                    maxW: 6,
                    maxH: 12,
                    resizeHandles: ['se']
                  })
                }
              } else {
                return parentLayout.push(newChildItem)
              }
            })
            oldItem.layout = parentLayout;
            newLayout.push(oldItem)
          } else if (itemChecked.children && itemChecked.children.length === 1) {
            let childKey = itemChecked.children[0].key
            let oldChildItem = dashboardLayout.find(d => d['i'] === childKey);
            if (oldChildItem) {
              newLayout.push(oldChildItem)
            } else {
              if (childKey.includes('pie')) {
                newLayout.push({
                  i: childKey,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((i * 2) % (6)),
                  y: ((i * 2) % (3)),
                  w: 2,
                  h: 2,
                  minW: 1,
                  minH: 1,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              } else if (childKey.includes('ranking_table')) {
                newLayout.push({
                  i: childKey,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((i * 3) % (6)),
                  y: Infinity,
                  w: 2,
                  h: 2,
                  minW: 2,
                  minH: 2,
                  maxW: 4,
                  maxH: 4,
                  resizeHandles: ['se']
                })
              } else {
                newLayout.push({
                  i: childKey,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((i * 3) % (6)),
                  y: Infinity,
                  w: 3,
                  h: 2,
                  minW: 3,
                  minH: 2,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              }
            }
          } else {
            newLayout.push(oldItem)
          }
        } else {
          // can't find item then make a new one
          if (itemChecked.children && itemChecked.children.length > 1) {
            let parentLayout = []
            let parentHeight = 0;
            let parentWidth = 0;
            let parentDraggable = true;
            itemChecked.children.forEach((child, j) => {
              if (child.key.includes('ranking_table')) {
                parentWidth += 2
                if (parentWidth % 6 === 0) { parentHeight += 2 }
                parentLayout.push({
                  i: child.key,
                  isBounded: false,
                  isDraggable: true,
                  isResizable: true,
                  x: ((j * 4) % (6)),
                  y: Infinity,
                  w: 2,
                  h: 2,
                  minW: 2,
                  minH: 2,
                  maxW: 4,
                  maxH: 4,
                  resizeHandles: ['se']
                })
              } else {
                parentWidth += 4
                if (parentWidth % 6 === 0) { parentHeight += 2 }
                parentDraggable = false
                parentLayout.push({
                  i: child.key,
                  isBounded: false,
                  isDraggable: false,
                  isResizable: true,
                  x: ((j * 4) % (6)),
                  y: Infinity,
                  w: 4,
                  h: 2,
                  minW: 3,
                  minH: 2,
                  maxW: 6,
                  maxH: 12,
                  resizeHandles: ['se']
                })
              }
            })
            newLayout.push({
              i: itemChecked.key,
              layout: parentLayout,
              isBounded: false,
              isDraggable: parentDraggable,
              isResizable: true,
              x: ((i * 3) % (6)),
              y: Infinity,
              w: parentWidth > 6 ? 6 : parentWidth,
              h: parentHeight,
              minW: 2,
              minH: 2,
              maxW: 6,
              maxH: 18,
              resizeHandles: ['se']
            })
          } else {
            let key = itemChecked.children && itemChecked.children.length === 1 ? itemChecked.children[0].key : itemChecked.key
            if (key.includes('ranking_table')) {
              let finalWidth = 0
              if (0 < width && width < 6) {
                finalWidth = width
                width += 2
              } else {
                width = 2
                finalWidth = 0
              }
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: true,
                isResizable: true,
                x: finalWidth,
                y: Infinity,
                w: 2,
                h: 2,
                minW: 2,
                minH: 2,
                maxW: 4,
                maxH: 4,
                resizeHandles: ['se']
              })
            } else if (key.includes('bar_chart')) {
              let finalWidth = 0
              if (0 < width && width < 6) {
                finalWidth = width
                width += 4
              } else {
                width = 4
                finalWidth = 0
              }
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: false,
                isResizable: true,
                x: finalWidth,
                y: Infinity,
                w: 4,
                h: 2,
                minW: 2,
                minH: 2,
                maxW: 6,
                maxH: 12,
                resizeHandles: ['se']
              })
            } else if (key === 'practice_focused_clients') {
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: true,
                isResizable: true,
                x: 0,
                y: Infinity,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2,
                maxW: 6,
                maxH: 12,
                resizeHandles: ['se']
              })
            } else {
              let finalWidth = 0
              if (0 < width && width < 6) {
                finalWidth = width
                width += 6
              } else {
                width = 6
                finalWidth = 0
              }
              newLayout.push({
                i: key,
                isBounded: false,
                isDraggable: true,
                isResizable: true,
                x: finalWidth,
                y: Infinity,
                w: 6,
                h: 3,
                minW: 3,
                minH: 2,
                maxW: 6,
                maxH: 12,
                resizeHandles: ['se']
              })
            }
          }
        }
      }
    })

    return newLayout;
  }

  const handleDashboardSelections = (item, parentItemInfo = null) => {
    let itemsCheckedTrue = [];
    let newLayout = [];
    setDashboard((prevState) => {
      let oldDashInfo = _.cloneDeep(prevState);
      if (parentItemInfo) {
        let parentItem = oldDashInfo.selectedItems.find((c) => c.key === parentItemInfo.key);
        if (parentItem.children) {
          let childItem = parentItem.children.find((child) => child.key === item.key);
          childItem.checked = !childItem.checked
          let numberOfChildrenChecked = parentItem.children.filter(child => child.checked)
          parentItem.checked = numberOfChildrenChecked.length > 0
        }
      } else {
        let selectedChart = oldDashInfo.selectedItems.find((c) => c.key === item.key);
        let checkStatus = !selectedChart.checked
        if (selectedChart.children) {
          selectedChart.children = selectedChart.children.map((c) => {
            c.checked = checkStatus
            return c;
          })
        }
        selectedChart.checked = checkStatus;
      }

      oldDashInfo.selectedItems.forEach((c) => {
        if (c.checked) {
          if (c.children) {
            let clonedItem = _.cloneDeep(c);
            clonedItem.children = clonedItem.children.filter(child => child.checked)
            itemsCheckedTrue.push(clonedItem)
          } else {
            itemsCheckedTrue.push(c)
          }
        }
      })

      newLayout = dashboardSelectEditor(itemsCheckedTrue, oldDashInfo.layout)

      return { ...prevState, selectedItems: oldDashInfo.selectedItems, layout: newLayout, noChangesMade: false }
    })
  }

  const handleSelectAll = (select) => {
    setDashboard((prevState) => {
      let newLayout = []
      let oldDashInfo = _.cloneDeep(prevState);
      let allItems = oldDashInfo.selectedItems.map((item) => {
        if (item.children) {
          item.children = item.children.map((c) => {
            c.checked = select
            return c;
          })
        }
        item.checked = select;
        return item;
      })

      newLayout = dashboardSelectEditor(allItems, oldDashInfo.layout)

      return { ...prevState, selectedItems: allItems, layout: newLayout, noChangesMade: false }
    })
  }

  const handleCustomDashboardSelections = (customKey, item, parentItemInfo = null) => {
    let itemsCheckedTrue = [];
    let newLayout = [];
    setNaicsDashLayouts((prevState) => {
      let oldDashInfo = _.cloneDeep(prevState);
      return oldDashInfo.map((l) => {
        if (l.key === customKey?.key) {
          if (parentItemInfo) {
            let parentItem = l.selected_items.find((c) => c.key === parentItemInfo.key);
            if (parentItem?.children) {
              let childItem = parentItem.children.find((child) => child.key === item.key);
              childItem.checked = !childItem.checked
              let numberOfChildrenChecked = parentItem.children.filter(child => child.checked)
              parentItem.checked = numberOfChildrenChecked.length > 0
            }
          } else {
            let selectedChart = l.selected_items.find((c) => c.key === item.key);
            let checkStatus = !selectedChart.checked
            if (selectedChart.children) {
              selectedChart.children = selectedChart.children.map((c) => {
                c.checked = checkStatus
                return c;
              })
            }
            selectedChart.checked = checkStatus;
          }

          l.selected_items.forEach((c) => {
            if (c.checked) {
              if (c.children) {
                let clonedItem = _.cloneDeep(c);
                clonedItem.children = clonedItem.children.filter(child => child.checked)
                itemsCheckedTrue.push(clonedItem)
              } else {
                itemsCheckedTrue.push(c)
              }
            }
          })
    
          newLayout = dashboardSelectEditor(itemsCheckedTrue, l.dashboard_layout);

          // l.selected_items = l.selected_items?
          l.dashboard_layout = newLayout
          l.noChangesMade = false
        }
        return l
      })
    })
  }

  const handleCustomSelectAll = (customKey, select) => {
    setNaicsDashLayouts((prevState) => {
      let newLayout = []
      let oldDashInfo = _.cloneDeep(prevState);
      return oldDashInfo.map((l) => {
        if (l.key === customKey?.key) {

          let allItems = l.selected_items.map((item) => {
            if (item.children) {
              item.children = item.children.map((c) => {
                c.checked = select
                return c;
              })
            }
            item.checked = select;
            return item;
          })
          newLayout = dashboardSelectEditor(allItems, l.dashboard_layout)

          l.selected_items = allItems
          l.dashboard_layout = newLayout
          l.noChangesMade = false

        }
        return l
      })
    })
  }

  const createDashBoardView = async (newDashView) => {
    let newView = {
      name: newDashView.name,
      private: newDashView.viewVisibilty === 'only_me',
      report_type: 'practice',
      permission_details: newDashView.viewPermission,
      view_apply: newDashView.viewApply,
      selected_items: dashboard.selectedItems,
      dashboard_layout: dashboard.layout
    }

    try {
      const res = await fetch(`/dashboard_views`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newView),
      })

      const dashViewRes = await res.json()
      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        setDashboard((prevState) => {
          return {
            ...prevState,
            id: dashViewRes.current_view.id,
            noChangesMade: true
          }
        })
        setDashboardViewModalState(prevState => {
          return {
            ...prevState,
            current_view: dashViewRes.current_view,
            user_views: dashViewRes.user_views,
            firms_views: dashViewRes.firms_views
          }
        })
        toast.success('New view created!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      let errorMessage = dashViewRes.name ? `Name ${dashViewRes.name}` : 'New view was not created properly'
      toast.error(`Sorry something went wrong. ${errorMessage}.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const getDashBoardView = async (dashViewId) => {
    try {
      const res = await fetch(`/dashboard_views/${dashViewId}`, {
        method: 'GET',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        }
      })

      const dashViewRes = await res.json()
      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        let currentDash = dashViewRes['current_view']
        setDashboard((prevState) => {
          return {
            ...prevState,
            id: currentDash.id,
            selectedItems: currentDash.selected_items,
            layout: currentDash.dashboard_layout,
            noChangesMade: true
          }
        })
        setDashboardViewModalState(prevState => {
          return {
            ...prevState,
            current_view: currentDash
          }
        })
      }
    } catch (error) {
      console.log(error);
      toast.error(`Sorry something went wrong.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const updateDashBoardView = async (e = false, dashId = null, dashViewInfo = null) => {
    if (e) { e.preventDefault() }
    let dashViewId = dashId
    const updatedView = {
      report_type: 'firm',
      selected_items: dashboard.selectedItems,
      dashboard_layout: dashboard.layout
    }
    if (!dashViewId) dashViewId = dashboard.id
    if (dashViewInfo) {
      updatedView['name'] = dashViewInfo?.name
      updatedView['private'] = dashViewInfo?.viewVisibilty === 'only_me'
      updatedView['permission_details'] = dashViewInfo?.viewPermission
    }

    try {
      const res = await fetch(`/dashboard_views/${dashViewId}`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedView),
      })

      const dashViewRes = await res.json()
      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        setDashboard((prevState) => {
          return {
            ...prevState,
            noChangesMade: true
          }
        })
        setDashboardViewModalState((prevState) => {
          return {
            ...prevState,
            current_view: dashViewRes.current_view,
            user_views: dashViewRes.user_views,
            firms_views: dashViewRes.firms_views
          }
        })
        toast.success('Changes saved!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error('Sorry something went wrong. Changes to view could not be saved.', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const deleteDashBoardView = async (e, dashViewId) => {
    e.preventDefault()
    try {
      const res = await fetch(`/dashboard_views/${dashViewId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        }
      })

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        let defaultView = dashboardViewModalState.firms_views.find(v => v.name === 'Default')
        let currentViewDeleted = dashViewId === dashboardViewModalState.current_view.id
        setDashboardViewModalState(prevState => {
          let oldUserViews = prevState.user_views
          let newUserViews = oldUserViews.filter(v => v.id !== dashViewId)
          let oldFirmsViews = prevState.firms_views
          let newFirmsViews = oldFirmsViews.filter(v => v.id !== dashViewId)

          if (currentViewDeleted) {
            return {
              ...prevState,
              current_view: defaultView,
              user_views: newUserViews,
              firms_views: newFirmsViews
            }
          } else {
            return {
              ...prevState,
              user_views: newUserViews,
              firms_views: newFirmsViews
            }
          }
        })

        setDashboard((prevState) => {
          if (currentViewDeleted) {
            return {
              id: defaultView.id,
              selectedItems: defaultView.selected_items,
              layout: defaultView.dashboard_layout,
              noChangesMade: true
            }
          } else {
            return prevState
          }
        })

        toast.success('View was deleted!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error);
      toast.error('Sorry something went wrong. Try again later.', {
        position: 'top-right',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const handleDashboardViewModal = (action, info = null) => {
    setDashboardViewModalState(prevState => {
      if (action === 'close') {
        return { ...prevState, isOpen: false, action: 'close' }
      } else if (action === 'edit_view') {
        let currentView = prevState.current_view
        let noViewEdit = currentView.permission_details !== 'view_only' || prevState.user_views.find(v => v.id === currentView.id)
        let currentInfo = !info ? currentView : info
        if (!noViewEdit) {
          toast.error(`Sorry You Are NOT Allowed to Edit this Dashboard View. You need to be the owner of this dashboard view in order to edit.`, {
            position: 'top-right',
            autoClose: 10000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
          });
          return prevState
        } else {
          return { ...prevState, isOpen: true, action: action, edit_view: currentInfo }
        }
      } else {
        return { ...prevState, isOpen: true, action: action, edit_view: {} }
      }
    })
  }

  const handleOnLayoutChange = (dashBoardType, newLayout, parentLayout = null) => {
    let currentView = dashboardViewModalState.current_view
    let noChangesVal = currentView.permission_details === 'view_only' && !dashboardViewModalState.user_views.find(v => v.id === currentView.id)

    if (dashBoardType === 'parentMyDashBoard') {
      setDashboard((prevState) => {
        let oldLayout = prevState.layout;
        let modifiedLayout = oldLayout.map((ol) => {
          let findNewItem = newLayout.find(item => item.i === ol.i)
          if (findNewItem) {
            return { ...ol, ...findNewItem }
          } else {
            return ol;
          }
        })
        return { ...prevState, layout: modifiedLayout, noChangesMade: false }
      })
    }

    if (dashBoardType === 'childMyDashBoard') {
      setDashboard((prevState) => {
        let modifiedLayout = _.cloneDeep(prevState.layout);
        let findParentLayout = modifiedLayout.find(ol => ol.i === parentLayout.i)
        let findParentLayoutIndex = modifiedLayout.findIndex(ol => ol.i === parentLayout.i)
        if (findParentLayout) {
          findParentLayout.layout = findParentLayout.layout.map(pl => {
            let findNewItem = newLayout.find(item => item.i === pl.i)
            if (findNewItem) {
              return { ...pl, ...findNewItem }
            } else {
              return pl;
            }
          })

          modifiedLayout[findParentLayoutIndex] = findParentLayout
        }
        return { ...prevState, layout: modifiedLayout, noChangesMade: false }
      })
    }

  }

  const adjustLayoutForCols = (parentCols, childLayoutWithData) => {
    let childLayout = childLayoutWithData || []
    // parentCols is the same as ChildDashboard's cols or width in grid units
    return childLayout.map(item => {
      const maxX = parentCols - item.w;
      // If item is too far right, shift it left
      if (item.x > maxX) {
        return { ...item, x: Math.max(0, maxX) };
      }

      return item;
    });
  }

  const handleCustomLayoutChange = (customKey, dashBoardType, newLayout, parentLayout = null) => {

    if (dashBoardType === 'parentMyDashBoard') {
      setNaicsDashLayouts((prevState) => {
        return prevState.map((l) => {
          if (l.key === customKey) {
            let modifiedLayout = l['dashboard_layout'].map((ol) => {
              let findNewItem = newLayout.find(item => item.i === ol.i)
              if (findNewItem) {
                let newItem = { ...ol, ...findNewItem }
                if (newItem?.layout) {
                  newItem.layout = adjustLayoutForCols(newItem.w, newItem.layout)
                }
                return newItem
              } else {
                return ol;
              }
            })
            l['dashboard_layout'] = modifiedLayout
            l['noChangesMade'] = false
          }
          return l
        })
      })
    }

    if (dashBoardType === 'childMyDashBoard') {
      setNaicsDashLayouts((prevState) => {
        return prevState.map((l) => {
          if (l.key === customKey) {
            let modifiedLayout = _.cloneDeep(l['dashboard_layout'])
            let findParentLayout = modifiedLayout.find(ol => ol.i === parentLayout.key)
            let findParentLayoutIndex = modifiedLayout.findIndex(ol => ol.i === parentLayout.key)
            if (findParentLayout) {
              findParentLayout.layout = findParentLayout.layout.map(pl => {
                let findNewItem = newLayout.find(item => item.i === pl.i)
                if (findNewItem) {
                  return { ...pl, ...findNewItem }
                } else {
                  return pl;
                }
              })
              findParentLayout = resizeChildLayout(findParentLayout)
              modifiedLayout[findParentLayoutIndex] = findParentLayout
            }
            l['dashboard_layout'] = modifiedLayout
            l['noChangesMade'] = false
          }
          return l
        })
      })
    }
  }

  const handleToggleDraggable = (key, dashType = '', parent = null, customKey = '') => {
    let currentView = dashboardViewModalState.current_view
    let noChangesVal = currentView.permission_details === 'view_only' && !dashboardViewModalState.user_views.find(v => v.id === currentView.id)
    setDashboard((prevState) => {
      let newLayout = _.cloneDeep(prevState.layout);
      let item = newLayout.findIndex((l) => l.i === key);
      if (item > -1) {
        newLayout[item].isDraggable = !newLayout[item].isDraggable
      } else {
        let parentItem = newLayout.find((l) => l.i === parent?.i);
        if (parentItem) {
          let childItem = parentItem.layout.find(c => c.i === key)
          if (childItem) { childItem.isDraggable = !childItem.isDraggable }
          parentItem.isDraggable = childItem.isDraggable
        }
      }
      return { ...prevState, layout: newLayout, noChangesMade: noChangesVal }
    })
  }

  const handleToggleDraggableCustom = (key, dashType = '', parent = null, customKey = '') => {
    setNaicsDashLayouts((prevState) => {
      let oldDashInfo = _.cloneDeep(prevState);
      return oldDashInfo.map((l) => { 
        if (l.key === customKey) {
          let newLayout = _.cloneDeep(l.dashboard_layout);
          let item = newLayout.findIndex((k) => k.i === key);
          if (item > -1) {
            newLayout[item].isDraggable = !newLayout[item].isDraggable
          } else {
            let parentItem = newLayout.find((k) => k.i === parent.i);
            if (parentItem) {
              let childItem = parentItem.layout.find(c => c.i === key)
              if (childItem) { childItem.isDraggable = !childItem.isDraggable }
              parentItem.isDraggable = childItem.isDraggable
            }
          }
          l.dashboard_layout = newLayout
          l.noChangesMade = false
        }
        return l
      })
    })
  }
  // setDashboard((prevState) => {
  //   let item = newLayout.findIndex((l) => l.i === key);
  //   if (item > -1) {
  //     newLayout[item].isDraggable = !newLayout[item].isDraggable
  //   } else {
  //     let parentItem = newLayout.find((l) => l.i === parent.i);
  //     if (parentItem) {
  //       let childItem = parentItem.layout.find(c => c.i === key)
  //       if (childItem) { childItem.isDraggable = !childItem.isDraggable }
  //       parentItem.isDraggable = childItem.isDraggable
  //     }
  //   }
  //   return { ...prevState, layout: newLayout, noChangesMade: noChangesVal }
  // })

  const handleSubmit = async (e = false, isNaicsOnly = false, naicsString = '') => {
    e ? e.preventDefault() : null
    let res;
    setIsLoading(true)
    try {
      if (isNaicsOnly) {
        res = await fetch(`/api/v1/practice_reportable?report=firm&naics_string=${naicsString}&revenue_band=${selectedFilters.revenue_band}&region=${selectedFilters.region}&partner=${selectedFilters.partner}&office=${selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`, {
          headers: {
            'X-CSRF-Token': window.token,
          }
        })
        const json = await res.json();
        if (!json.insufficient_data) {
          setData(prevState => {
            return {
              ...prevState,
              naics_averages: json.naics_averages,
              dashboard_calculations: json.dashboard_calculations,
              child_count: json.child_count,
              drillup: json.drillup,
              drillup_link: json.drillup_link,
              drillup_text: json.drillup_text,
              filterOptions: json.filter_options_obj,
              insufficientData: json.insufficient_data,
              page: json.page,
              pieTopLevelArr: json.pie_top_level_arr,
              selected_filters: json.selected_filters,
              rankingData: json.snapshot_info,
              tree: json.tree,
              year: json.year,
              yearRange: json.yearRange,
            }
          })
        } else {
          setData(prevState => {
            return {
              ...prevState,
              insufficientData: json.insufficient_data
            }
          })
        }
        setIsLoading(false)
      } else {
        res = await fetch(`/api/v1/practice_reportable?report=firm&naics_string=${selectedFilters.naics_string}&revenue_band=${selectedFilters.revenue_band}&region=${selectedFilters.region}&partner=${selectedFilters.partner}&office=${selectedFilters.office}&status=${selectedFilters.status === 'All' ? '' : selectedFilters.status}&year=${selectedFilters.year}&commit=filter`, {
          headers: {
            'X-CSRF-Token': window.token,
          }
        })
        const json = await res.json();

        if (!json.insufficient_data) {
          setData(prevState => {
            return {
              ...prevState,
              naics_averages: json.naics_averages,
              dashboard_calculations: json.dashboard_calculations,
              child_count: json.child_count,
              drillup: json.drillup,
              drillup_link: json.drillup_link,
              drillup_text: json.drillup_text,
              filterOptions: json.filter_options_obj,
              user_focused_clients_info: json.user_focused_clients_info,
              insufficientData: json.insufficient_data,
              page: json.page,
              pieTopLevelArr: json.pie_top_level_arr,
              rankingData: json.snapshot_info,
              selected_filters: json.selected_filters,
              tree: json.tree,
              year: json.year,
              yearRange: json.yearRange,
            }
          })
        } else {
          setData(prevState => {
            return {
              ...prevState,
              insufficientData: json.insufficient_data
            }
          })
        }
        setIsLoading(false)
      }
    } catch (error) {
      console.log(error)
      toast.error('Sorry something went wrong. Please try again later.', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      setIsLoading(false)
    }
  };

  const findSelectedIndustry = () => {
    let selectedCode = ''
    let selectedIndustry = ''

    if (data.drillup) {
      const allNAICS = Object.keys(data['naics_averages']).filter(n => n !== 'ALL');
      if (selectedFilters.naics_string.includes('-')) {
        allNAICS.forEach((el, i) => {
          if (el.naics !== 'ALL') {
            i > 0 ? selectedCode += ', ' + el.naics : selectedCode += el.naics
          }
        })
        data.filterOptions['naics_string'].forEach(element => {
          element[0] === selectedFilters.naics_string ? selectedIndustry = element[1] : null
        });
      } else {
        selectedCode = allNAICS[0]
        data.filterOptions['naics_string'].forEach(element => {
          element[0] === selectedCode ? selectedIndustry = element[1] : null
        });
      }
    } else {
      selectedCode = 'All'
    }
    selectedIndustry = selectedIndustry.split(' - ').join('')
    return [selectedCode, selectedIndustry]
  }

  const handleMouseEnter = (item) => {
    setActivePopover(item);
  };

  const handleMouseLeave = (item) => {
    if (item === 'leave') {
      setActivePopover(null);
    }
  };

  const openFiltersModal = () => {
    setFiltersModalIsOpen(true)
  }

  const closeFiltersModal = () => {
    setFiltersModalIsOpen(false)
  }

  const saveTabOrder = async (newTabs = null) => {
    let updates = []
    if (newTabs) {
      let newTabsOrder = newTabs.map((t, i) => {
        t.tab_order = i + 1
        updates.push({ id: t.id, tab_order: t.tab_order })
        return t
      })
      setReportsOnTabs(newTabsOrder);
    } else {
      updates = reportsOnTabs.map((t) => { return { id: t.id, tab_order: t.tab_order } })
    }

    try {
      const res = await fetch("/api/v1/preferences/update_views", {
        method: "PATCH",
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates
        }),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error("Error saving tab order:", error);
    }
  }

  const saveSubTabOrder = async (newSubTabs) => {
    if (!newSubTabs?.length) return;

    const parentTab = reportsOnTabs.find((tab) => tab.id === newSubTabs[0].parent_id);
    if (!parentTab) return;

    const updatedTabs = reportsOnTabs.map((tab) => {
      if (tab.id !== parentTab.id) return tab;

      return {
        ...tab,
        sub_tabs: newSubTabs.map((subTab, index) => ({
          ...subTab,
          tab_order: index + 1,
        })),
      };
    });

    setReportsOnTabs(updatedTabs);

    const updates = newSubTabs.map((subTab, index) => ({
      id: subTab.id,
      tab_order: index + 1,
    }));

    try {
      const res = await fetch("/api/v1/preferences/update_views", {
        method: "PATCH",
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates
        }),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error("Error saving sub tab order:", error);
    }
  }

  const updateTabActiveView = async (newTab, action = null) => {
    setActiveTab(newTab.key);
    let updates = [];

    const newTabs = reportsOnTabs.map((t) => {
      if (t.key === newTab.key) {
        updates.push({ ...t, active_view: true });
        return { ...t, active_view: true };
      } else if (t.active_view) {
        updates.push({ ...t, active_view: false });
        return { ...t, active_view: false };
      }
      return t;
    });

    setReportsOnTabs(action === 'addNote' ? [...newTabs, newTab] : newTabs);

    if (newTab.report === 'generated_naics_main_tab' && newTab?.details?.naics_string) {
      const cacheKey = newTab.details.naics_string;
      const hasCachedPracticeData = Boolean(practiceData?.[cacheKey]);

      if (!hasCachedPracticeData) {
        practiceApiCall(newTab.details);
      }
    }

    try {
      const res = await fetch("/api/v1/preferences/update_views", {
        method: "PATCH",
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates
        }),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error("Error saving tab order:", error);
    }
  }

  const updateSubTabActiveView = async (newSubTab) => {
    const updates = [];
    const updatedTabs = reportsOnTabs.map((parentTab) => {
      if (!parentTab.sub_tabs?.length) return parentTab;

      const containsSubTab = parentTab.sub_tabs.some((subTab) => subTab.id === newSubTab.id || subTab.key === newSubTab.key);
      if (!containsSubTab) return parentTab;

      const nextSubTabs = parentTab.sub_tabs.map((subTab) => {
        const isSelectedSubTab = subTab.id === newSubTab.id || subTab.key === newSubTab.key;

        if (isSelectedSubTab) {
          updates.push({ id: subTab.id, active_view: true });
          return { ...subTab, active_view: true };
        }

        if (subTab.active_view) {
          updates.push({ id: subTab.id, active_view: false });
        }

        return { ...subTab, active_view: false };
      });

      return { ...parentTab, sub_tabs: nextSubTabs };
    });

    setReportsOnTabs(updatedTabs);

    try {
      const res = await fetch("/api/v1/preferences/update_views", {
        method: "PATCH",
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          updates: updates
        }),
      });

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error("Error saving sub tab active view:", error);
    }
  }

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newTabs = Array.from(reportsOnTabs);
    const [movedTab] = newTabs.splice(result.source.index, 1);
    newTabs.splice(result.destination.index, 0, movedTab);
    saveTabOrder(newTabs);
  };

  const handleNaicsSortChange = (sortBy) => {
    setNaicsSortConfig((prevState) => {
      if (prevState.sortBy === sortBy) {
        return { ...prevState, isDesc: !prevState.isDesc }
      }
      return { sortBy, isDesc: true }
    })
  }

  const updateCustomLayout = async (customKey) => {
    let activeCustomLayout = naicsDashLayouts.find(c => c.key === customKey)
    try {
      const res = await fetch(`/dashboard_views/update_naics_layout`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': window.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          custom_layout: {
            id: activeCustomLayout.id,
            selected_items: activeCustomLayout.selected_items,
            dashboard_layout: activeCustomLayout.dashboard_layout
          }
        }),
      })

      if (!res.ok) {
        throw new Error('Network response was not ok.');
      } else {
        setNaicsDashLayouts((prevState) => {
          return prevState.map((l) => {
            if (l.key === customKey) {
              l['noChangesMade'] = true
            }
            return l
          })
        })
        toast.success('Changes saved!', {
          position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log(error)
      toast.error(`Sorry something went wrong. ${error}.`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }
  }

  const renderEditDashboard = () => {
    let naicsActiveTab = reportsOnTabs.find(t => t.key === activeTab);
    let subActiveTab = naicsActiveTab?.sub_tabs?.find(s => s.active_view) || null;
    let gridItemsSelected = dashboard.selectedItems;
    let noChangesM = dashboard.noChangesMade;

    if (activeTab !== 'dashboard') {
      const activeCustomLayout = naicsDashLayouts.find((c) => c.key === subActiveTab?.key);
      noChangesM = activeCustomLayout ? activeCustomLayout.noChangesMade : true;
      gridItemsSelected = activeCustomLayout?.selected_items;
    }

    const saveChangesButton = () => {
      if (activeTab !== 'dashboard') {

        return noChangesM ? null : (
          <button
            className="save-dashboard-btn"
            onClick={() => updateCustomLayout(subActiveTab?.key)}
          >
            Save Changes
          </button>
        );
      }

      return dashboard.noChangesMade ? null : (
        <button className="save-dashboard-btn" onClick={() => updateDashBoardView()}>
          Save Changes
        </button>
      );
    }

    return (
      <li key='edit-dashboard-li-item' id='edit-dashboard-tabs' className='edit-dashboard-section'>
        {saveChangesButton()}
        <EditDashboard
          key={'edit-dashboard-popup'}
          subActiveTab={subActiveTab}
          dashboardLayoutType={''}
          gridItemsSelected={gridItemsSelected}
          noChangesMade={noChangesM}
          handleSelectAll={handleSelectAll}
          handleDashboardSelections={handleDashboardSelections}
          handleCustomSelectAll={handleCustomSelectAll}
          handleCustomDashboardSelections={handleCustomDashboardSelections}
          updateCustomLayout={updateCustomLayout}
          updateDashBoardView={updateDashBoardView}
          page={'firm'}
        />
      </li>
    )
  };

  const handleIndustryOptionsForSubTabs = (value, excluded) => {
    let focusedOptions = excluded ? [...excludeIndustryRankings] : [...includeIndustryRankings]
    let otherOptions = excluded ? [...includeIndustryRankings] : [...excludeIndustryRankings]

    if (focusedOptions.find(f => f.code === value.code)) {
      focusedOptions = focusedOptions.filter(s => s.code !== value.code)
      otherOptions.push(value)
    } else {
      otherOptions = otherOptions.filter(s => s.code !== value.code)
      focusedOptions.push(value)
    }

    if (excluded) {
      if (otherOptions.length > 5) {
        setRankError('Please select 5 industries to focus on. Remove any included industries to add a new industry to the list.')
      } else {
        setRankError('')
        focusedOptions = focusedOptions.map(fo => {
          fo.included = false
          return fo
        })
        otherOptions = otherOptions.map(oo => {
          oo.included = true
          return oo
        })
        setExcludeIndustryRankings(focusedOptions)
        setIncludeIndustryRankings(otherOptions)
      }
    } else {
      otherOptions = otherOptions.map(oo => {
        oo.included = false
        return oo
      })
      focusedOptions = focusedOptions.map(fo => {
        fo.included = true
        return fo
      })
      setRankError('')
      setExcludeIndustryRankings(otherOptions)
      setIncludeIndustryRankings(focusedOptions)
    }
    
  }

  const industryIncludeExcludeOptions = (excluded = false) => {
    let optionDivStyle = excluded ? 'naics-rank-exclude-options-wrap' : 'naics-rank-include-options-wrap';
    let options = excluded ? excludeIndustryRankings : includeIndustryRankings;
    let optionLabel = excluded ? 'Excluded' : 'Included';

    return (
        <div className='options-section'>
            <span>{optionLabel}</span>
            <div className={optionDivStyle}>
                {options.map((item, i) => {
                    return (
                        <div className='naics-rank-btns' key={`${item.code}-${i}`} onClick={() => handleIndustryOptionsForSubTabs(item, excluded)}><span>{`${item.code} - ${item.description}`}</span></div>
                    )
                })}
            </div>
        </div>
    )
  }

  const LoadingOverlay = () => {
    return (
      <div className='client-overlay'>
        <LoaderGraphic logoLoader={true} />
      </div>
    );
  };

  if (data.year > 0) {
    let naicsInfo = findSelectedIndustry()
    let naicsDisplayFilterTop = naicsInfo[1] ? `NAICS: ${naicsInfo[0]}, ${naicsInfo[1]}` : `NAICS: ${naicsInfo[0]}`
    return (
      <div style={{ opacity: (isLoading || generatingReports ? 0.6 : 1) }}>
        {practiceCalcsProgressBar ?
          <ProgressBarModal
            job={'PracticeCalculationWorker'}
            refresh={true}
            path={'/group_reports/firm'}
          /> : null}
        <div id='sticky-topnav-left-btns'>
            <ExportPracticeFirmPDF
                {...props}
                name={'Firm'}
                data={data}
                naicsInfo={naicsInfo}
                activeTab={activeTab}
                noteTabs={noteTabs}
                reportsOnTabs={reportsOnTabs}
                companyNotes={companyNotes}
                dashboard={dashboard}
                PDFPrintModalOpen={PDFPrintModalOpen}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                handleSubmit={handleSubmit}
                onChangeNotes={onChangeNotes}
                setIsLoading={setIsLoading}
                dashboardViewModalState={dashboardViewModalState}
                practiceData={practiceData}
                practiceTableState={practiceTableState}
                naicsDashLayouts={naicsDashLayouts}
                practiceApiCall={practiceApiCall}
                getDashBoardView={getDashBoardView}
                handleDashboardViewModal={handleDashboardViewModal}
                handleOnLayoutChange={handleOnLayoutChange}
                handleToggleDraggable={handleToggleDraggable}
                handleToggleDraggableCustom={handleToggleDraggableCustom}
                page={'firm'}
                year={data.year}
                yearRange={[data.year]}
            />
            <ExportDropdown
                filters={selectedFilters}
                planAccess={{
                    export_to_excel: true,
                }}
                printRef={componentRefs}
                page={'firm'}
                year={data.year}
                xlsx={true}
            />
        </div>
        <div id='sticky-topnav-right-btns'>
          <button className='hide-on-print' onClick={() => setIsOpen(true)}><FontAwesomeIcon icon={faQuestionCircle} /></button>
        </div>
        <div id='sticky-side-btns'>
          <span
            className='filters-btn-span hide-on-print'
            onMouseEnter={() => handleMouseEnter('filters')}
            onMouseLeave={() => handleMouseLeave('leave')}
          >
            <button className='filters-btn'><FontAwesomeIcon icon={faAnglesLeft} onClick={() => openFiltersModal()} /></button>
            {activePopover === 'filters' && (
              <div className='filters-popover'>
                Display Filters
              </div>)}
          </span>
        </div>
        <Modal
          overlayClassName='industry-rank-modal-overlay'
          className='industry-rank-modal-content'
          isOpen={industryRankModalOpen}
          onRequestClose={() => setIndustryRankModalOpen(false)}
          shouldCloseOnOverlayClick={true}
          closeTimeoutMS={0}
          contentLabel='Industry Rank Modal'
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
            <header className='company-modal-header'>
              <h1 className='client-company-name'>Rank Your Industries</h1>
            </header>
            {generatingReports ? <LoadingOverlay /> : null}
            <p style={{ margin: 0 }}>{data?.naics_rank_present ? "We suggest prioritizing these industries based on your given data. Feel free to select the priority list for generating AI reports for your industries. Only the 5 industries will be used to generate AI reports." : "Please rank your industries. Feel free to select the priority list for generating AI reports for your industries. Only the 5 industries will be used to generate AI reports." }</p>
            <p style={{ textAlign: 'center' }}>Click anywhere outside of pop up to close.</p>
            <p className='error-message'>{rankError}</p>
            <button className='generate-ai-naics-reports-btn btn btn-primary hide-on-print' onClick={() => generateNaicsSubTabs()}>Generate AI Reports for these Industries</button>
            <div className='naics-rank-options-container'>
              {industryIncludeExcludeOptions()}
              {industryIncludeExcludeOptions(true)}
            </div>
          </div>
        </Modal>
        <Modal
          className={{
            base: 'client-modal-content',
            afterOpen: 'client-modal-content_after-open',
            beforeClose: 'client-modal-content_before-close',
          }}
          overlayClassName={{
            base: 'overlay-base',
            afterOpen: 'overlay-base_after-open',
            beforeClose: 'overlay-base_before-close',
          }}
          isOpen={filtersModalIsOpen}
          onRequestClose={closeFiltersModal}
          shouldCloseOnOverlayClick={true}
          closeTimeoutMS={0}
          contentLabel='Firm Report Filters Modal'
        >
          <div>
            <header className='company-modal-header'>
              <h1 className='client-company-name'>Report Filters</h1>
            </header>
            <div className='report-filters-container'>
              <div className='client-info-div'>
                <p>{naicsDisplayFilterTop}</p>
              </div>
              <PRDropdownFilter filterOptions={data.filterOptions} handleSubmit={handleSubmit} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
            </div>
          </div>
        </Modal>
        <DashboardViewModal
          dashboardViewModalState={dashboardViewModalState}
          report={'firm'}
          handleDashboardViewModal={handleDashboardViewModal}
          createDashBoardView={createDashBoardView}
          deleteDashBoardView={deleteDashBoardView}
          updateDashBoardView={updateDashBoardView}
        />
        <Modal
          className={{
            base: 'new-report-tab-content',
            afterOpen: 'new-report-tab-content_after-open',
            beforeClose: 'new-report-tab-content_before-close',
          }}
          overlayClassName={{
            base: 'new-report-tab-overlay-base',
            afterOpen: 'new-report-tab-overlay-base_after-open',
            beforeClose: 'new-report-tab-overlay-base_before-close',
          }}
          isOpen={openNotesForm}
          onRequestClose={() => setOpenNotesForm(false)}
          shouldCloseOnOverlayClick={false}
          closeTimeoutMS={0}
          contentLabel='Add New Tab Name Modal'
        >
          <div className='new-report-tab-container'>
            <h1 className='company-modal-header'>Add a New Notes Tab</h1>
            <form id='new-report-tab-form' onSubmit={(e) => createNewNotesTab(e)}>
              <p className='error-message'>{notesInput.error}</p>
              <div>
                <label>New Notes Name:</label>
                <input value={notesInput.name} onChange={(e) => handleNewNotesName(e.target.value)} />
              </div>
              <div className='text-editor-permissions'>
                  <span>Note Permissions:</span>
                  <div className='radio-qs'>
                    <div className='radio-q'>
                        <input
                            type='radio'
                            id='permit-edit-and-view'
                            name='dashboard-view-permissions'
                            value='private'
                            checked={notesInput.permissions === 'private'}
                            onChange={(e) => handleNotePermissions(e.target.value)}
                            required
                        />
                        <label htmlFor='permit-edit-and-view'>Private</label>
                    </div>
                    <div className='radio-q'>
                        <input
                            type='radio'
                            id='permit-view'
                            name='dashboard-view-permissions'
                            value='view_only'
                            checked={notesInput.permissions === 'view_only'}
                            onChange={(e) => handleNotePermissions(e.target.value)}
                        />
                        <label htmlFor='permit-view'>All Can View Only</label>
                    </div>
                    <div className='radio-q'>
                        <input
                            type='radio'
                            id='permit-view'
                            name='dashboard-view-permissions'
                            value='edit_and_view'
                            checked={notesInput.permissions === 'edit_and_view'}
                            onChange={(e) => handleNotePermissions(e.target.value)}
                        />
                        <label htmlFor='permit-view'>All Can View and Edit</label>
                    </div>
                  </div>
              </div>
              <button className='run-report-btn' type='submit'>Create New Notes</button>
            </form>
            <button className='run-report-btn' type='button' onClick={() => setOpenNotesForm(false)}>CANCEL</button>
          </div>
        </Modal>
        <div className='money-report-component money-content'>
          {isLoading ? <LoadingOverlay /> : null}
          <div className='firm-ai-btns' style={{pointerEvents: isLoading ? 'none' : 'auto'}}>
            {navbar.user_type === 'Admin' ? <button className='generate-ai-reports-btn btn btn-primary hide-on-print' onClick={() => handleAIReportConfirmation()}>Generate AI Reports</button> : null}
            {navbar.user_type === 'Admin' ? <button className='generate-ai-reports-btn btn btn-primary hide-on-print' onClick={() => setIndustryRankModalOpen(true)}>Rank Your Industries</button> : null}
          </div>
          <div style={{pointerEvents: isLoading ? 'none' : 'auto'}}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="tabs" direction="horizontal">
                {(provided) => (
                  <ul
                    id="nav-tabs-practice-report"
                    className="report-tab-list"
                    role="tablist"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {reportsOnTabs.map((tab, index) => {
                      let styleName = tab.key.includes('firm_notes') || tab.key.includes('firm_naics_main') ? 'tab-item' : 'report-tab-item'
                      let styleActiveName = tab.key.includes('firm_notes') || tab.key.includes('firm_naics_main') ? 'active' : 'normal-active'

                      return (
                        <Draggable key={tab.key} draggableId={tab.key.toString()} index={index}>
                          {(provided) => (
                            <li
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              key={tab.key}
                              className={
                                activeTab === tab.key
                                  ? `${styleName} ${styleActiveName}`
                                  : `${styleName}`
                              }
                              role="presentation"
                              onClick={(e) => {
                                e.stopPropagation();
                                updateTabActiveView(tab);
                              }}
                            >
                              <span className="tab-name">{tab.name}</span>
                              {
                                tab.key.startsWith('firm_notes')
                                  ? (<button
                                      type="button"
                                      className="view-close-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        deleteReportTab(tab)
                                      }}
                                    >
                                      &times;
                                    </button>)
                                  : null
                              }
                            </li>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                    <div className="relative">
                      <button className="add-view-btn hide-on-print" onClick={() => setOpenNotesForm(true)}>
                        + Add Notes
                      </button>
                    </div>
                    {renderEditDashboard()}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          {data.insufficientData
            ? <h1>{data.insufficientData}</h1>
            : <FirmReport 
              ref={componentRefs}
              {...props}
              generatedNotesByTab={generatedNotesByTab}
              handleGenereateNoteChange={handleGenereateNoteChange}
              revertToGeneratedReponse={revertToGeneratedReponse}
              data={data}
              naicsInfo={naicsInfo}
              reportsOnTabs={reportsOnTabs}
              activeTab={activeTab}
              companyNotes={companyNotes}
              dashboard={dashboard}
              PDFPrintModalOpen={PDFPrintModalOpen}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              handleSubmit={handleSubmit}
              onChangeNotes={onChangeNotes}
              displayPages={displayPages}
              naicsSortConfig={naicsSortConfig}
              handleNaicsSortChange={handleNaicsSortChange}
              dashboardViewModalState={dashboardViewModalState}
              getDashBoardView={getDashBoardView}
              handleDashboardViewModal={handleDashboardViewModal}
              handleOnLayoutChange={handleOnLayoutChange}
              handleCustomLayoutChange={handleCustomLayoutChange}
              handleToggleDraggable={handleToggleDraggable}
              handleToggleDraggableCustom={handleToggleDraggableCustom}
              isLoading={isLoading}
              practiceData={practiceData}
              practiceTableState={practiceTableState}
              naicsDashLayouts={naicsDashLayouts}
              saveSubTabOrder={saveSubTabOrder}
              updateSubTabActiveView={updateSubTabActiveView}
              handleTableChanges={handleTableChanges}
              handleFocusedClients={handleFocusedClients}
            />
          }
        </div>
        {props.super_user
          ? (<form id='mapping-form' className='hide-on-print' action='/practice_calculations' acceptCharset='UTF-8' data-remote='true' method='post' >
            <input type='hidden' name='authenticity_token' value={window.token} />
            <input name='utf8' type='hidden' value='✓' />
            <input
              type='submit'
              value='Update Practice Calculations'
              className='submit-mapping-button btn btn-primary success pull-right'
              onClick={() => {
                document.querySelector('.money-report-component').style.zIndex = 0;
                setPracticeCalcsProgressBar(true);
              }}
            />
          </form>)
          : null
        }
        {!copilotOpen && navbar.user_type === 'Admin' && (
          <button
            className="copilot-floating-btn"
            onClick={() => setCopilotOpen(true)}
            title="Ask Peerview"
          >
            <i className="fa fa-comments" />
          </button>
        )}
        <CopilotSlideOut
          isOpen={copilotOpen}
          onClose={() => setCopilotOpen(false)}
          activeTab={null}
          companyName={navbar.parent_company_name}
          userType={navbar.user_type}
          setupProd={navbar.setup}
          page={'firm'}
          filters={selectedFilters}
          dataGiven={data.naics_averages}
        />
      </div>
    )
  } else {
    return (
      <div style={{ 'height': '80vh', 'paddingTop': '30vh' }}>
        <LoaderGraphic logoLoader={true} />
      </div>
    )
  }
}

export default FirmReportContainer;
